import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    youDeposit: 'You deposit',
    deposit: 'Approve {token} & Deposit',
    depositDisabled: 'Deposits into the Bitcoin Sonic Vault are closed.',
    switchNetwork: 'Switch to {chain}',
    disclaimer:
      'All vaults contain smart contract risk and various degrees of economic risk. This includes, but is not limited to, liquidity provisioning which can result in impermanent loss and use of leverage, meaning there is liquidation risk.',
    depositFee: 'Deposit fee',
    approveSuccess: 'Approve successful!',
    approveSuccessMessage: 'Now you can proceed with the deposit.',
    withdraw: 'Withdraw',
  },
};
